<template>
  <div class="grid <md:min-h-screen">
    <div class="grid-area-stack">
      <base-picture
        class="absolute full"
        fit="cover"
        :props-img="{ class: 'w-full', style: 'object-position: top right', role: 'presentation' }"
        :src="{
          sm: 'https://assets.thenorthface.eu/image/upload/q_auto,f_auto/v1723688110/240328-TNF-ss24-404-lp-m',
          md: 'https://assets.thenorthface.eu/image/upload/q_auto,f_auto/v1723688110/240328-TNF-ss24-404-lp-m',
          lg: 'https://assets.thenorthface.eu/image/upload/q_auto,f_auto/v1723688110/240328-TNF-SS24-404-LP-RIGHT',
        }"
      />
    </div>
    <div class="grid-area-stack <lg:flex">
      <div class="px-4 py-16 md:max-w-2/3">
        <p class="mt-4 italic lg:mt-6 lg:text-xl">
          {{ $t.maintenance.ERR5xx.seoText }}
        </p>
        <h1 class="mt-4 display-2">
          {{ $t.maintenance.ERR5xx.title }}
        </h1>
        <p class="mt-4 lg:mt-6 lg:text-md">
          {{ $t.maintenance.ERR5xx.message }}
        </p>
        <vf-button class="mt-8 <md:w-full" @click="clearError({ redirect: '/' })">
          {{ $t.maintenance.ERR5xx.cta }}
        </vf-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { $feature, $t } = useNuxtApp()
useSeoMeta({ title: $t.error, robots: $feature.enableNoindexOnErrorPages ? 'noindex, nofollow' : '' })
</script>
